<!--
 * @Description: 申请开票-发票邮寄
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseForm ref="formRef" label-position="top" :model="formData">
    <div class="form-dialog__title">
      <h1>发票邮寄</h1>
    </div>
    <template v-for="(item, index) in formData" :key="index">
      <div class="form-dialog__content" v-if="item.isDefault">
        <BaseFormItem label="收件人" prop="name">
          <BaseInput
            class="form-dialog__w280"
            type="text"
            placeholder="请输入"
            disabled
            v-model="item.name"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem label="联系电话" prop="phone">
          <BaseInput
            class="form-dialog__w280"
            type="text"
            placeholder="请输入"
            disabled
            v-model="item.phone"
          ></BaseInput>
        </BaseFormItem>
        <!-- TODO: address字段没有地方编辑只有mailAddress可编辑，此处为空，如果有BUG则转给产品 -->
        <BaseFormItem label="企业地址" prop="mailAddress">
          <BaseInput
            class="form-dialog__w280"
            type="text"
            placeholder="请输入"
            disabled
            v-model="item.mailAddress"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem label="邮箱" prop="email">
          <BaseInput
            class="form-dialog__w280"
            type="tel"
            placeholder="请输入"
            disabled
            v-model="item.email"
          ></BaseInput>
        </BaseFormItem>
      </div>
    </template>
  </BaseForm>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import { BaseForm, BaseFormItem, BaseInput } from 'xrk-components';
import { BasicInformationData } from '@V/invoice/src/data-source/types';

const formRef = ref(null);
const formData = defineModel<BasicInformationData['addressList']>();
</script>
